const META_PIXEL_ID = "1636500431032582";

type FbqFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[];
  loaded?: boolean;
  version?: string;
  push?: FbqFunction;
};

declare global {
  interface Window {
    fbq?: FbqFunction;
    _fbq?: FbqFunction;
  }
}

let metaPixelInitialized = false;

export const initializeMetaPixel = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  if (!window.fbq) {
    const fbq: FbqFunction = function () {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments as unknown as unknown[]);
      } else {
        fbq.queue?.push(arguments);
      }
    };

    window.fbq = fbq;

    if (!window._fbq) {
      window._fbq = fbq;
    }

    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
  }

  const existingScript = document.querySelector<HTMLScriptElement>(
    "script[data-meta-pixel]"
  );

  if (!existingScript) {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    script.dataset.metaPixel = META_PIXEL_ID;

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode?.insertBefore(script, firstScript);
  }

  if (!metaPixelInitialized) {
    window.fbq("init", META_PIXEL_ID);
    metaPixelInitialized = true;
  }
};

export const trackMetaPixelPageView = () => {
  if (typeof window === "undefined") return;

  initializeMetaPixel();
  window.fbq?.("track", "PageView");
};

